// utils/pixelNormalize.ts — normalisasi PII RAW utk pixel (split dari pixelPii.ts)
// Dipakai oleh metaPixel/tiktokPixel/googlePixel (fisik+digital) — satu sumber kebenaran.
// - Meta fbq: kirim RAW (em lower+trim, ph digit-only, fn/ln lower); pixel auto-hash SHA256.
// - TikTok ttq.identify: wajib pre-hash SHA256 (hex lower) sebelum kirim.
// - Google gtag set user_data: wajib pre-hash SHA256 (hex lower).

// Normalisasi PII RAW (untuk Meta fbq 'set' userData — jangan di-hash duluan)
export function normalizeEmailRaw(email?: string): string | undefined {
    const e = String(email || '').trim().toLowerCase();
    return e || undefined;
}
// Normalisasi phone ke digit E.164 TANPA '+' (cth 0812.. → 62812..) — WAJIB sama
// dengan backend (normalizeWhatsApp utk Meta, 0→62 utk TikTok/Google) supaya hash
// browser == hash server untuk nomor yang sama (fix mismatch EMQ 2026-09-22).
export function normalizePhoneE164Digits(phone?: string): string | undefined {
    let d = String(phone || '').trim();
    if (!d) return undefined;
    if (d.startsWith('+')) d = d.slice(1);
    d = d.replace(/\D/g, '');
    if (!d) return undefined;
    if (d.startsWith('0')) d = `62${d.slice(1)}`;
    return d;
}
export function normalizePhoneRaw(phone?: string): string | undefined {
    return normalizePhoneE164Digits(phone);
}
export function normalizeNamePartsRaw(name?: string): { fn?: string; ln?: string } {
    const n = String(name || '').trim();
    if (!n) return {};
    const parts = n.split(/\s+/);
    const fn = parts[0]?.trim().toLowerCase() || undefined;
    const ln = parts.slice(1).join(' ').trim().toLowerCase() || undefined;
    return { fn: fn || undefined, ln: ln || undefined };
}

// Geo normalisasi untuk ct/st (lower, strip prefix wilayah, hapus non-alnum) — cocok untuk Meta CAPI + tiktok
export function normalizeGeoRaw(v?: string): string | undefined {
    if (!v) return undefined;
    const s = String(v).toLowerCase().replace(/^(kota|kabupaten|kab|provinsi|prov|kecamatan|kelurahan)\s+/i, '').replace(/[^a-z0-9]/g, '');
    return s || undefined;
}
export function normalizePostalRaw(v?: string): string | undefined {
    const d = String(v || '').replace(/\D/g, '');
    return d || undefined;
}
export function normalizeCountryRaw(v?: string): string | undefined {
    const c = String(v || 'id').toLowerCase().replace(/[^a-z]/g, '');
    return c.length === 2 ? c : undefined;
}
